import React from "react";
import { DataProcessorViewModel } from "../SystemOverview.types";
import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { useUrlProvider } from "../../../useUrlProvider";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";
import DotLegalLink from "../../../common/components/dotLegalLink/DotLegalLink";

export interface SystemOverviewLegalEntityDialogProps {
    legalEntities: Array<DataProcessorViewModel> | undefined;
    onDialogClose: () => void;
    header: string;
}

function SystemOverviewLegalEntityDialog(props: SystemOverviewLegalEntityDialogProps) {
    const { getLegalEntityUrl, getGroupEntityUrl } = useUrlProvider();
    const { permissions } = useUserContext();

    const getLegalEntity = (row: DataProcessorViewModel) => {
        if (row.link) {
            let link = row.link.startsWith("http") ? row.link : `https://${row.link}`;
            return (
                <DotLegalHeader key={row.id} marginBottom={1} headerStyle={"extraSmall"} fontWeight={400}>
                    <DotLegalLink bold linkColor={"primary"} to={link}>
                        {row.link}
                    </DotLegalLink>
                </DotLegalHeader>
            );
        } else if (row.isGroupEntity && permissions.canManageGroupEntities) {
            return (
                <DotLegalHeader key={row.id} marginBottom={1} headerStyle={"extraSmall"} fontWeight={400}>
                    <DotLegalLink bold linkColor={"primary"} to={getGroupEntityUrl(row.id)}>
                        {row.name}
                    </DotLegalLink>
                </DotLegalHeader>
            );
        } else if (row.isGroupEntity) {
            return (
                <DotLegalHeader key={row.id} marginBottom={1} headerStyle={"extraSmall"} fontWeight={400}>
                    {row.name}
                </DotLegalHeader>
            );
        } else {
            return (
                <DotLegalHeader key={row.id} marginBottom={1} headerStyle={"extraSmall"} fontWeight={400}>
                    <DotLegalLink bold linkColor={"primary"} to={getLegalEntityUrl(row.id)}>
                        {row.name}
                    </DotLegalLink>
                </DotLegalHeader>
            );
        }
    };

    return (
        <DotLegalDialog header={props.header} size="sm" hideOkButton buttonOkText={""} onDialogClose={props.onDialogClose} open onOkClick={() => {}}>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", marginBottom: 2, marginTop: -0.5 }}>
                {props.legalEntities?.map((entity) => (
                    <Box sx={{ marginTop: 1 }} key={entity.id + entity.link}>
                        {getLegalEntity(entity)}
                    </Box>
                ))}
            </Box>
        </DotLegalDialog>
    );
}

export default SystemOverviewLegalEntityDialog;
